// import React from 'react';
import { render } from '@testing-library/react';
import React, { useState, useEffect, PureComponent, useRef, useMemo, useCallback, Fragment } from 'react';
// import Accordion from 'react-bootstrap/Accordion'

// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';

import {
    BarChart,
    Bar,
    Cell,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    
    Legend,
    ReferenceLine,
    ResponsiveContainer,
  } from 'recharts';
import "./EpicfinanceTrends.css";
import { isEqual } from "lodash";
import * as ReactBootstrap from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { useParams } from 'react-router-dom';

import config from '../config';
import Sidebar from '../SideMenu';


const EpicFixedIncomeFunction = () => {
  // $('.btn-setting')[0].click();
  const [StateSession, setStateSession] = useState([]);
  const [SessionResponse, setSessionResponse] = useState([]);
  const [KeyMapResponse, setKeyMapResponse] = useState([]); 
  const [MarketContentResponse, setMarketContentResponse] = useState([]);
  const [PeopleApiResponse, setPeopleApiResponse] = useState([]); 
  const [KeyMap, setKeyMap] = useState([]); 
  const [MarketContent, setMarketContent] = useState([]);
  const [PeopleApi, setPeopleApi] = useState([]);
  const [MarketText, setMarketText] = useState([]);
  
  const [status, setstatus] = useState([]);

  const [UniqueKeyContacts, setUniqueKeyContacts] = useState([]);
  const [KeyNameone, setKeyNameone] = useState([]); 
  const [KeyLinkone, setKeyLinkone] = useState([]); 
  const [KeyNametwo, setKeyNametwo] = useState([]); 
  const [KeyLinktwo, setKeyLinktwo] = useState([]); 
  const [KeyNamethree, setKeyNamethree] = useState([]); 
  const [KeyLinkthree, setKeyLinkthree] = useState([]); 
  const [KeyNamefour, setKeyNamefour] = useState([]); 
  const [KeyLinkfour, setKeyLinkfour] = useState([]); 
  const [KeyNamefive, setKeyNamefive] = useState([]); 
  const [KeyLinkfive, setKeyLinkfive] = useState([]); 
  
  const functionArraySetting=()=>{
    
      $('.btn-setting')[0].click();


  }
  const LoopingFunction=()=>{
  
    var content;
    var ArrLinkResponse = [];
  var ArrKeyLink = [];
    var KeyName1;
    var KeyLink1;
    
    var KeyName2;
    var KeyLink2;
    
    var KeyName3;
    var KeyLink3;
    
    var KeyName4;
    var KeyLink4;
    
    var KeyName5;
    var KeyLink5;
    
      
    var allKeys = ["KeyName"];
    
        for(let j=0 ; j< KeyMap.length ;j++){
      
          let obj={};
      
          for(let i=0 ; i< MarketContent.length ;i++){
      
           
            if(MarketContent[i].id == 35){

            if(MarketContent[i].id == KeyMap[j].allpages_id){
     
  
              var MarketText = MarketContent[i].content
       
              
                setMarketText(MarketText);
  
  
              for(let k=0;k<PeopleApi.length;k++){
                
                if(KeyMap[j].key_id == PeopleApi[k].id){
            
                  obj[allKeys[0]] = PeopleApi[k].name ;
  
        
          
                  ArrLinkResponse.push(PeopleApi[k].name)
                  ArrKeyLink.push(PeopleApi[k].id)
                }
  
              }           
            }
          }
        }
      } 
        // Arrreplica = ArrLinkResponse;
      //   for(let l=0; l< ArrLinkResponse.length;l++){
  
      //     for(let m=0; m< Arrreplica.length;m++){
      //     if(ArrLinkResponse[l].keyName == Arrreplica[m].keyName){
      //       console.log("SAMEEE")
      //     }
  
      //    }
      //  }
  
     
        const startingArray = [1, 2, 2, 3, 2, 3, 3, 3];
  
        function unique(array){
          return array.filter(function(el, index, arr) {
              return index == arr.indexOf(el);
          });
        }
        
        const uniqueArray = unique(ArrLinkResponse);
      if(uniqueArray){
  
      }      
      KeyName1 = uniqueArray[3];
      KeyLink1 = ArrKeyLink[3];
      
      KeyName2 = uniqueArray[0];
      KeyLink2 = ArrKeyLink[0];
      
      KeyName3 = uniqueArray[1];
      KeyLink3 = ArrKeyLink[1];

      KeyName4 = uniqueArray[2];
      KeyLink4 = ArrKeyLink[2];

      setKeyNameone(KeyName1);
      setKeyLinkone(KeyLink1);

      setKeyNametwo(KeyName2);
      setKeyLinktwo(KeyLink2);
      
      setKeyNamethree(KeyName3);
      setKeyLinkthree(KeyLink3);

      setKeyNamefour(KeyName4);
      setKeyLinkfour(KeyLink4);





    }
  
  
  const SettingFunction=()=>{

    setStateSession(SessionResponse);

 
    const ArrServiceResponse = [];
    setKeyMap(KeyMapResponse);
    setMarketContent(MarketContentResponse)
    setPeopleApi(PeopleApiResponse)
  
    // LoopingFunction();
 
  

    LoopingFunction();
    
  }
  

    $( document ).ready(function() {
      SettingFunction();
      
      if ($(".accordion__item__header").length > 0) {
  
        var active = "active";
        var activedis = "active-dis";
        $(".accordion__item__header").on("click", function (event) {
          event.stopImmediatePropagation();
       
          $(this).toggleClass(active);
          $(this).find(".navlink").toggleClass(activedis);
          
        $(this).next("div").slideToggle(200);
        });
        }
       if( $("section").hasClass('key-contacts')){
        $("div").removeClass('footer-container-line')
        // alert("hi");
       }
    });
    
      async function fetchMyService3API(){

        const url =config.apiPath+'/people_api';
        
         fetch(url).then(resp=> resp.json())
         .then (resp => {
      
       
      
          setPeopleApiResponse(resp)
      
        })
          
         .catch(e=>{
          
         })
      
           
      
      
      
      };
      async function fetchMyServiceAPI(){
      
        const url =config.apiPath+'/key_mapdata';
        
        
         fetch(url).then(resp=> resp.json())
         .then (resp => {
      
          
      
          setKeyMapResponse(resp)
      
        })
          
         .catch(e=>{
   
         })
      
           
      
      
      
      };
      async function fetchMyService2API(){
      
        const url =config.apiPath+'/market_contentapi';
        //const url ='http://127.0.0.1:8000/market_contentapi';
        const Localurl ='https://epicipprojects.com/market_contentapi';
        
         fetch(url).then(resp=> resp.json())
         .then (resp => {
       
      
          setMarketContentResponse(resp)
          setstatus(true)
          document.getElementById("headerButton").click();
      
        })  
         .catch(e=>{
          
         })
      
         
      
      };
      


async function fetchMyAPI(){
  fetch(config.apiPath+'/session_data').then(resp => resp.json()).then(resp =>  {
  
  
    setSessionResponse(resp);
  
  
  })
}
      useEffect(()=>{

        fetchMyAPI();
        fetchMyService2API();
        fetchMyServiceAPI();
        fetchMyService3API();
        
      },[])

return(

<Fragment>

    { status === true ? 
    
<section className="main-box">
  <div className="container">
    <div className="row">
      <div className="col-lg-3 col-md-3 col-sm-4">
        <Sidebar StateSession={{StateSession:StateSession,"url":"Epic-FixedIncome","group":"Fixed Income"}}/>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-8 offset-md-1">
    
    
      {/* <ul class="nav nav-tabs" role="tablist">
        <li className="nav-item nav-item-tabs latest-news"> <a className="nav-link active latest-news" data-toggle="tab" id="summaryButton" onClick={latestNews} href="#nine" role="tab">Latest News</a> </li>
      </ul> */}
    
    
    <div class="Section__SectionContent-sc-1iot0f7-2 " dangerouslySetInnerHTML={{ __html: MarketText }}>

    </div>
    <div class="Section__SectionContent-sc-1iot0f7-2 " >
          <h3>Our products</h3><br/>
        <button type="button" id="headerButton" onClick={functionArraySetting} className="btn-primary float-right hidden">Header</button> 

                <p>
                    {/* <NavLink to="/markets/EpiciNfaUcitsFundRoute" className="navlink a decoration-none">EPIC - NFA Global Bond Fund UI (UCITS)<span className="fa fa-angle-right"></span></NavLink><br/> */}
                    <NavLink to="/markets/EpicNextGenUcitsFundRoute" className="navlink a decoration-none">EPIC - Next Generation Bond Fund (UCITS)<span className="fa fa-angle-right"></span></NavLink><br/>
                    {/* <a href=config.apiPath+"/login_user" className="navlink a">Renminbi Bond Fund (PCC)<span className="fa fa-angle-right"></span></a><br/>
                    <a href=config.apiPath+"/login_user" className="navlink a">Next Generation Bond Fund (PCC)
                        <span className="fa fa-angle-right"></span>
                    </a> */}
           

                
                    <NavLink to="/markets/SegregatedMandates" className="navlink a decoration-none">Segregated Mandates<span className="fa fa-angle-right"></span></NavLink><br/>
                 
                {/* { StateSession !== 0 ?
                <NavLink to="/markets/EpicRNBpcc" className="navlink a " >EPIC - Renminbi Bond Fund (PCC)<span className="fa fa-angle-right"></span></NavLink>
                :
                <a href={config.apiPath+"/login_user"} className="navlink a">EPIC - Renminbi Bond Fund (PCC)<span className="fa fa-angle-right"></span></a>
                }
                    <br/> */}

                </p>
        


        {/* <div class="PaginationButtons__Wrapper-sc-1murby2-0 frVXsi"><a rel="next" href="/news/2">← Older Articles</a></div> */}
        </div>
  </div>
    </div>
  </div>
  <section class="key-contacts sec-key">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h4>Key contacts:</h4>
        <hr />
      </div>

    </div>

    <div class="row">
      <div class="col-md-3">
        <p><strong><a href={config.apiPath+"/people/#"+KeyLinktwo}>{KeyNametwo}</a></strong> <br />
          {/* andy.seaman@epicpe.com */}
          </p>
      </div>

      <div class="col-md-3">
        <p ><strong><a href={config.apiPath+"/people/#"+KeyLinkthree}>{KeyNamethree}</a></strong> <br />
          {/* darren.goodwin@epicpe.com */}
          </p>
      </div>
      <div class="col-md-3">
        <p ><strong><a href={config.apiPath+"/people/#"+KeyLinkfour}>{KeyNamefour}</a></strong> <br />
          {/* frederick.coldham@epicpe.com */}
          </p>
      </div>
      <div class="col-md-3">
        <p ><strong><a href={config.apiPath+"/people/#"+KeyLinkone}>{KeyNameone}</a></strong> <br />
          {/* frederick.coldham@epicpe.com */}
          </p>
      </div>





    </div>
    <br/>
    <br/>
    <span>For General Enquiries:-<a href = "mailto: markets@epicip.com"><span> markets@epicip.com</span></a></span>
  </div>
  </section>
</section>
:<div className="center"><ReactBootstrap.Spinner animation="border"/></div>  }
{/* } */}
</Fragment>
)

}
 
export default EpicFixedIncomeFunction;

